import React from "react";

import { makeStyles } from "@material-ui/core/styles";

import { Button } from "react-admin";

import { ShowIcon } from "../../../components/common/iconography";
import { deepRedirect } from "../../../utils/utils";

const useStyles = makeStyles((theme) => ({
  alignRight: {
    textAlign: "right",
  },
}));

export const ShowInventoryButton = ({ record, backPath, ...props }) => {
  const classes = useStyles();

  const handleOpen = () => {
    debugger;
    deepRedirect(props.history, `/inventories/${record.id}/show`, backPath, {});
  };

  if (!record) return null;
  return (
    <div className={classes.alignRight}>
      <Button label="SHOW" size="small" color="primary" onClick={handleOpen}>
        <ShowIcon />
      </Button>
    </div>
  );
};
